export const titleStyles = {
 display: 'flex',
 alignItems: 'center',
 justifyContent: 'space-between',
 fontSize: 14,
 fontWeight: 500,
 mb: 2,
};
